export const securityColors = {
  acceptable: '#83d325',
  rudimentary: '#e9a602',
  inadequate: '#fc3733'
};

export const fadedSecurityColors = {
  acceptable: '#dcead1',
  rudimentary: '#ffebd6',
  inadequate: '#fecece'
};

const chartDataOrder = [
  'critical.acceptable',
  'critical.rudimentary',
  'critical.inadequate',
  'nonCritical.acceptable',
  'nonCritical.rudimentary',
  'nonCritical.inadequate'
];

const generateSecurityChartDataItem = (data, colors, criticality, adequacy) => {
  return {
    color: colors[criticality][adequacy],
    value: data[criticality][adequacy]
  };
};

const generateSecurityChartData = (data, colors) => {
  return chartDataOrder.map(element => {
    const [criticality, adequacy] = element.split('.');
    return generateSecurityChartDataItem(data, colors, criticality, adequacy);
  });
};

export const generateSecurityOverviewChartData = (data) => {
  return generateSecurityChartData(data, securityColors);
};

export const generateSecurityDetailChartData = (data, criticality, adequacy) => {
  return generateSecurityChartData(data, fadedSecurityColors).map((item, index)=> {
    const indexInOrder = chartDataOrder
      .indexOf([criticality, adequacy].join('.'));

    if (index === indexInOrder) {
      return generateSecurityChartDataItem(
        data,
        securityColors,
        criticality,
        adequacy
      );
    }

    return item;
  });
};

const calculateSecurityOverviewSliceChartOffset = (data, criticality, adequacy) => {
  const dataIndex = chartDataOrder.indexOf([criticality, adequacy].join('.'));
  const offsetSlice = chartDataOrder.slice(0, dataIndex);

  if (offsetSlice.length === 0) {
    return 0;
  }

  return offsetSlice.reduce((acc, key) => {
    const [criticality, adequacy] = key.split('.');
    return acc + data[criticality][adequacy];
  }, 0);
};

const calculateSecurityOverviewSliceChartTotal = (data) => {
  return [
    data.critical.acceptable,
    data.critical.rudimentary,
    data.critical.inadequate,
    data.nonCritical.acceptable,
    data.nonCritical.rudimentary,
    data.nonCritical.inadequate
  ].reduce((acc, val) => acc + val, 0);
};

const getSecurityOverviewSliceChartStrokeWidth = (data, criticality) => {
  return {
    'critical': 16,
    'nonCritical': 2
  }[criticality];
};

const getSecurityOverviewSliceChartFontSize = (data, criticality) => {
  return  {
    'critical': 30,
    'nonCritical': 16
  }[criticality];
};

export const generateSecurityOverviewSliceChartProps = (data, criticality, adequacy) => {
  const offset = calculateSecurityOverviewSliceChartOffset(data, criticality, adequacy);
  const total = calculateSecurityOverviewSliceChartTotal(data);

  return {
    progressColor: securityColors[adequacy],
    outlineColor: fadedSecurityColors[adequacy],
    strokeWidthPercent: getSecurityOverviewSliceChartStrokeWidth(data, criticality),
    fontSize: getSecurityOverviewSliceChartFontSize(data, criticality),
    value: data[criticality][adequacy],
    offset,
    total
  };
};

export const generateSecurityOverviewSliceLabel = (data, criticality, adequacy) => {
  const count = data[criticality][adequacy];

  if (criticality === 'critical') {
    if (adequacy === 'acceptable') {
      return `${count} of your critical correlations are at least minimally indexed.`;
    } else if (adequacy === 'rudimentary') {
      return `${count} of your critical correlations have rudimentary indexing data.`;
    }

    return `${count} of your critical correlations need more indexed data.`;
  }

  if (adequacy === 'acceptable') {
    return `There are ${count} non-critical correlations for which you have at least minimal data.`;
  } else if (adequacy === 'rudimentary') {
    return `${count} of your non-critical correlations have rudimentary indexing data.`;
  }

  return `There are ${count} non-critical correlations you could explore if you increased indexing.`;
};

export const generateSecurityAnalysisLegendSubtext = (adequacy) => {
  switch (adequacy) {
      case 'acceptable':
        return 'More than 60% indexed';
      case 'rudimentary':
        return 'Between 20% and 60% indexed';
      case 'inadequate':
        return 'Less than 20% indexed';
  }
};




// WEBPACK FOOTER //
// ./src/utils/securityAnalysis.js